import styled from "styled-components";

export const ContainerFiltros = styled.div`
  width: 100%;
`;
